export enum SelectAttributeModalTypes {
	DOC_EXPLORER = 'docExplorer',
	DRILL_MENU = 'drillMenu',
	ORG_ENRICHMENT = 'orgEnrichment',
	PREVIEW_WIDGET = 'preview'
}
